import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ICompany } from 'src/app/pages/companies/models/company.interface';
import { CompanyService } from 'src/app/pages/companies/services/company.service';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { SessionService } from 'src/app/shared/services/session.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { DashboardsService } from '../../services/dashboards.service';
import { IListByFilterMedico } from 'src/app/pages/doctors/models/doctor';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';

@Component({
  selector: 'app-add-new-my-dashboard',
  templateUrl: './add-new-my-dashboard.component.html'
})
export class AddNewMyDashboardComponent implements OnInit {
  @Output() recarregarListagem = new EventEmitter();

  formAberto = false;

  form = new UntypedFormGroup({
    tabName: new UntypedFormControl('', [Validators.required]),
    dashboardNumber: new UntypedFormControl(1, [Validators.required]),
    companyId: new UntypedFormControl(null, [Validators.required])
  });

  opcoesCompany: ICompany[] = [];

  constructor(
    private readonly dashboardsService: DashboardsService,
    private readonly companyService: CompanyService,
    private readonly toastService: ToastService,
    private readonly sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.getListCompany();

    const companyId = this.sessionService.getSession().companyId;
    if (companyId) {
      this.form.get('companyId')?.patchValue(companyId);
      this.form.get('companyId')?.disable();
    }
  }

  salvarDashboard(): void {
    if (this.form.invalid) {
      this.toastService.toast('Preencha todos os campos obrigatórios antes de salvar.', EMessageType.Error);
      this.form.markAllAsTouched();
      return;
    }

    const dashboard = this.form.getRawValue();

    this.dashboardsService.adicionarMyDashboard(dashboard).subscribe((res) => {
      if (res.messages && res.messages.length > 0) {
        this.toastService.toast(res.messages);
      }

      if (res.isSucceed) {
        this.form.reset();
        this.formAberto = false;
        this.recarregarListagem.emit();
      }
    });
  }

  private getListCompany(): void {
    const partnerId = this.sessionService.getSession().partnerId;
    const accountRole = this.sessionService.getSession().accountRole;
    const companyId = this.sessionService.getSession().companyId;

    const filtros: IListByFilterMedico = {
      pageNumber: 0,
      pageSize: 9999,
      orderBy: EOrdenacao.AlfabeticaAZ
    };

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    this.companyService.listarTodasEmpresas(filtros).subscribe((resposta) => {
      this.opcoesCompany = resposta.data;
    });
  }
}
